import { render, staticRenderFns } from "./ItemFormatted.vue?vue&type=template&id=3aac4b90"
import script from "./ItemFormatted.vue?vue&type=script&lang=js"
export * from "./ItemFormatted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports